export const API_METHOD = Object.freeze({
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  PATCH: 'PATCH',
});

export const RESPONSE_STATUSES = {
  INTERNAL_ERROR: 500,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504,
  CREATED: 201,
  BAD_REQUEST: 400,
};

export const NAMESPACE_API_PATH = Object.freeze({
  PUBLIC: '/web/public',
  PRIVATE: '/web/private/client',
});
